/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GuestyEventEntityType } from './guestyEventEntityType';
import { SortOrder } from './sortOrder';
import { GuestyEventStatus } from './guestyEventStatus';


export interface GuestyEventFilter { 
    /**
     * The page number of the result (the first page is 0)
     */
    page_number?: number;
    /**
     * The number of items returned in each page
     */
    page_size?: number;
    sort_order?: SortOrder;
    /**
     * The processing statuses to include. All statuses are included when not specified
     */
    statuses?: Array<GuestyEventStatus>;
    /**
     * The entity types to include. All entity types are included when not specified
     */
    entity_types?: Array<GuestyEventEntityType>;
    /**
     * The ID of the Guesty entity the events refer to
     */
    entity_id?: string;
    /**
     * The Guesty event type (e.g. reservation.new)
     */
    event_type?: string;
    timestamp_from?: string;
    timestamp_to?: string;
}

